// This checks if user has OKX Wallet extension installed
// and adds cookie that allows to use Metamask alongside OKX
export function createOkxCookie(): void {
  if (window.okxwallet !== undefined) {
    const selectWalletCookie = /selectWallet=([^;]+)/.exec(
      document.cookie,
    )?.[1];

    if (selectWalletCookie === undefined) {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      document.cookie = `selectWallet=Metamask; expires=${date.toUTCString()}; path=/`;
      window.location.reload();
    }
  }
}
